import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';

const AnimatedWords = ({ lines = [], className = '', stagger = 0.06, duration = 0.5, delay = 0, accentMap = [], auto = true }) => {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        if (!containerRef.current || !auto) return;
        const ctx = gsap.context(() => {
            const words = containerRef.current.querySelectorAll('[data-animated-word]');
            gsap.fromTo(words, { yPercent: 100 }, {
                yPercent: 0,
                duration,
                ease: 'power3.out',
                stagger,
                delay,
                clearProps: 'transform'
            });
        }, containerRef);
        return () => ctx.revert();
    }, [stagger, duration, delay, auto]);

    return (
        <span ref={containerRef} className={className}>
            {lines.map((line, lineIdx) => {
                const words = String(line).split(' ');
                const accentIndices = Array.isArray(accentMap[lineIdx]) ? accentMap[lineIdx] : [];
                return (
                    <span key={lineIdx} className="animated-line" style={{ display: 'block' }}>
                        {words.map((word, idx) => {
                            const isAccent = accentIndices.includes(idx);
                            return (
                                <span key={idx} className="word-mask" style={{ display: 'inline-block', overflow: 'hidden' }}>
                                    <span data-animated-word className={`word${isAccent ? ' accent' : ''}`} style={{ display: 'inline-block' }}>{word}</span>
                                    {idx < words.length - 1 ? '\u00A0' : null}
                                </span>
                            );
                        })}
                    </span>
                );
            })}
        </span>
    );
};

export default AnimatedWords;
